import { type ISelectionStrategy } from './abstract.selection.strategy';

export class DefaultManyCheckingSelectionStrategy implements ISelectionStrategy {
    constructor(private selection) {}

    public update(items) {
        let selected = [];
        this.selection.getSelectedItems().then(res => {
            selected = res;
            res.forEach(itemSelected => {
                if (!items.find(item => item.id === itemSelected)) {
                    this.selection.setSelection({ id: itemSelected }, false);
                }
            });
        });
    }
}
